// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3OZht","inner":"Form_inner__1CDhu","range":"Form_range__1vKeR","name":"Form_name__VcoUc","actions":"Form_actions__GZxyp"};